(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mobx"), require("antd"), require("ecCom"), require("React"), require("mobxReact"), require("loadjs"));
	else if(typeof define === 'function' && define.amd)
		define(["mobx", "antd", "ecCom", "React", "mobxReact", "loadjs"], factory);
	else if(typeof exports === 'object')
		exports["comsMobx"] = factory(require("mobx"), require("antd"), require("ecCom"), require("React"), require("mobxReact"), require("loadjs"));
	else
		root["comsMobx"] = factory(root["mobx"], root["antd"], root["ecCom"], root["React"], root["mobxReact"], root["loadjs"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_262__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition